var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.getButtonClass, { _active: _vm.active }],on:{"click":_vm.toggleFavoriteStatus}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }